import Footer from './Footer';

export default () => (
  <Footer>
    <p>
      WHY ARE PEOPLE FLOCKING TO COVE? BECAUSE WE MAKE INSURANCE SIMPLE!&nbsp;&nbsp;&nbsp;
      <i className="fal fa-2x fa-thumbs-up" />
    </p>
  </Footer>
);
